export const InvestorTypeEnum = {
  ENGAGED: 8,
  NOT_ENGAGED: 9,
};
